import { AxiosInstance } from "axios";
import { ICore } from "./interfaces";

export function getCommunicationPreferencesBuilder(apiClient: AxiosInstance) {
  return async function getCommunicationPreferences(): Promise<
    ICore.ICommPermission[]
  > {
    const response = await apiClient.get(`/accounts/notification-permissions/`);
    return response.data;
  };
}
